/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unused-vars */
import InputAdornment from "@mui/material/InputAdornment";
import CurrencyFormat from "react-currency-format";
import { Skeleton, TextField } from "@mui/material";
// eslint-disable-next-line import/no-extraneous-dependencies
import { ThemeProvider } from "@material-ui/styles";
import { createTheme } from "@material-ui/core/styles";

// eslint-disable-next-line import/no-duplicates
import { ptBR } from "date-fns/locale";
import React, { useState, useEffect, useContext, useRef, useMemo } from "react";

import { toast } from "react-toastify";
import { useListarUsuariosPorEquipe } from "services/api/Identity_Usuario";
import {
  PerfilHierarquico,
  useUsuariosPorPerfilHierarquico,
} from "services/api/Identity_Usuario/usuarios-por-perfil-hierarquico";
import { useTransformList } from "hooks/objectToLabelValue";
import color from "constants/color";
import { CARGO_CODES } from "constants/permissions";
import { CheckBox } from "components/checkBoxCommon/styles";
import { useMotivosDesquealificacao } from "services/api";
import { useListarOrigensLeads } from "services/api/Mobile_OrigemLead";
import { useTemperaturasLead } from "services/api/Mobile_Temperatura_Lead/temperaturas-lead";
import { useGetEtapas } from "services/api/Etapas_Subetapas/etapas-get";
import {
  useGetSubetapas,
  OrigemRequisicao,
} from "services/api/Etapas_Subetapas/subetapas-get";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { getEtiquetas } from "services/api/AppWeb_Lead/listar-etiquetas";
import ToggleBtnsColors from "components/toggleBtnsColors";
import {
  useFiltrosSalvos,
  useCriarFiltro,
  useExcluirFiltro,
  FiltroSalvo,
} from "services/api/AppWeb_Lead/filtros-salvos";
import { FiTrash2, FiEdit2 } from "react-icons/fi";
import SelectAutoCompleteG from "components/selectAutoCompleteG";
import InputComponent from "components/InputG";
import axiosLead from "../../../../services/lead";
import ToggleBtns from "../../../../components/toggleBtns";
import { Context } from "../../../../context/Context";
import * as IconsSVG from "../../../../assets/iconsSVG";
import MaterialUI from "../../../../material-UI";
import * as Styles from "./styles";
import ToggleBtnsFarol from "../../../../components/toggleBtnsFarol";
import { DivisorContainer } from "../../../../components/divisorContainer";
import { RenderByCargo } from "../../../../utils/RenderByCargo";
import { getTotalItensRetorno } from "../tableGrid/constants";

interface Props {
  codigoCargo2013: string | null;
  isOpen?: boolean;
  filters?: any;
  setFilters?: React.Dispatch<React.SetStateAction<any>>;
  onApply?: () => void;
}

const FiltersContent: React.FC<Props> = ({
  codigoCargo2013,
  isOpen,
  filters: filtersProp,
  setFilters: setFiltersProp,
  onApply,
}) => {
  const { idRegionalSistemaOrigem, usuarioDiretor, usuarioGerenteOnline } =
    useSelector<RootStateOrAny, AuthState>((state) => state.user);

  const isDiretor = usuarioDiretor === true;
  const showDiretorFilters = isDiretor || usuarioGerenteOnline;
  const isSuperintendente =
    codigoCargo2013 === CARGO_CODES.SUPERINTENDENTE && !isDiretor;
  const showHierarchy = showDiretorFilters || isSuperintendente;

  const [dataFilters, setDataFilters] = useState<any>({
    OrdenarPorRecentes: null,
    IdentificaCliente: null,
    FiltrarRecebidosPorTransferencia: null,
    InicioIntervaloTransferencia: null,
    FimIntervaloTransferencia: null,
    InicioIntervaloCadastroLead: null,
    FimIntervaloCadastroLead: null,
    FiltrarPorData: null,
    InicioIntervaloAtualizacaoLead: null,
    FimIntervaloAtualizacaoLead: null,
    SemEmpreendimentoInteresse: false,
    LeadsDesqualificados: false,
  });
  // const [origens, setOrigens] = useState<any>([]);
  const [zonasData, setZonasData] = useState<any>([]);
  const [produtos, setProdutos] = useState<any>([]);
  const [bairros, setBairros] = useState<any>([]);
  const [rendas, setRendas] = useState<Array<{ id: string; nome: string }>>([]);
  const [temperaturaData, setTemperaturaData] = useState<any>([]);
  const [empreendimentoData, setEmpreendimentoData] = useState<any>([]);
  const [objetivosData, setObjetivosData] = useState<any>([]);
  const [prazosData, setPrazosData] = useState<any>([]);
  const [errorDataCadastro, setErrorDataCadastro] = useState<boolean>(false);
  const [errorDataAtualizacao, setErrorDataAtualizacao] =
    useState<boolean>(false);
  const [disabledProdutoInteresse, setDisabledProdutoInteresse] =
    useState<boolean>(false);
  const [errorDataRecebidos, setErrorDataRecebidos] = useState<boolean>(false);
  const contextValue = useContext(Context);
  const filters = filtersProp ?? contextValue.filters;
  const setFilters = setFiltersProp ?? contextValue.setFilters;
  const [dataCriacaoInicioValida, setDataCriacaoInicioValida] =
    useState<boolean>(false);
  const [dataAtualizacaoInicioValida, setDataAtualizacaoInicioValida] =
    useState<boolean>(false);
  const [filterButtonDisabled, setFilterButtonDisabled] = useState(false);
  const [leadsDesqualificados, setLeadsDesqualificados] =
    useState<boolean>(false);
  const [canaisContato, setCanaisContato] = useState<any>([]);
  const [loadingCanais, setLoadingCanais] = useState<boolean>(false);

  const superintendenteSelecionado = dataFilters?.SuperintendenteSelecionado;
  const equipeSelecionada = dataFilters?.EquipeSelecionada;

  const { data: dataSuperintendentes } = useUsuariosPorPerfilHierarquico({
    queryKey: "filtro-carteira-superintendentes",
    perfil: PerfilHierarquico.Superintendente,
    enabled: Boolean(isOpen) && showDiretorFilters,
  });

  const { data: dataEquipesHierarquia } = useUsuariosPorPerfilHierarquico({
    queryKey: `filtro-carteira-equipes-${
      showDiretorFilters ? superintendenteSelecionado?.value || "self" : "self"
    }`,
    perfil: PerfilHierarquico.Gerente,
    idLider: showDiretorFilters
      ? superintendenteSelecionado?.value || null
      : null,
    enabled:
      Boolean(isOpen) &&
      ((showDiretorFilters && Boolean(superintendenteSelecionado)) ||
        isSuperintendente),
  });

  const { data: dataCorretoresHierarquia } = useUsuariosPorPerfilHierarquico({
    queryKey: `filtro-carteira-corretores-${equipeSelecionada?.value || "all"}`,
    perfil: PerfilHierarquico.Corretor,
    idLider: equipeSelecionada?.value || null,
    enabled: Boolean(isOpen) && showHierarchy && Boolean(equipeSelecionada),
  });

  const superintendentesOptions = useMemo(
    () =>
      dataSuperintendentes?.map((item) => ({
        value: item.idUsuario || item.id,
        label: item.nome,
      })) || [],
    [dataSuperintendentes]
  );

  const equipesHierarquiaOptions = useMemo(
    () =>
      dataEquipesHierarquia?.map((item) => ({
        value: item.idUsuario || item.id,
        label: item.nome,
      })) || [],
    [dataEquipesHierarquia]
  );

  const corretoresHierarquiaOptions = useMemo(
    () =>
      dataCorretoresHierarquia?.map((item) => ({
        value: item.id,
        label: item.nome,
      })) || [],
    [dataCorretoresHierarquia]
  );

  const [fetchedFilter, setFetchedFilter] = useState(false);

  // Filtros Salvos
  const [selectedFiltroId, setSelectedFiltroId] = useState<string>("");
  const [selectedFiltroNome, setSelectedFiltroNome] = useState<string>("");
  const [showSaveForm, setShowSaveForm] = useState(false);
  const [newFilterName, setNewFilterName] = useState("");
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [hasFilterChanges, setHasFilterChanges] = useState(false);
  const [confirmDeleteId, setConfirmDeleteId] = useState<string | null>(null);
  const [confirmDeleteNome, setConfirmDeleteNome] = useState<string>("");
  const [showRenameForm, setShowRenameForm] = useState(false);
  const [renameFilterName, setRenameFilterName] = useState("");
  const savedFiltersSnapshot = useRef<string>("");
  const initialFiltersSnapshot = useRef<string>("");

  const { data: filtrosSalvos, refetch: refetchFiltrosSalvos } =
    useFiltrosSalvos();
  const criarFiltro = useCriarFiltro();
  const excluirFiltro = useExcluirFiltro();

  const theme = createTheme({
    palette: {
      action: {
        disabled: "#ffffff",
      },
    },
  });

  useEffect(() => {
    if (dataFilters?.leadsDesqualificados) {
      setDataFilters({
        ...dataFilters,
        leadsDesqualificados: false,
      });
    }
    if (!dataFilters?.leadsDesqualificados) {
      setDataFilters({
        ...dataFilters,
        leadsDesqualificados: true,
      });
    }
  }, [dataFilters?.leadsDesqualificados]);

  useEffect(() => {
    if (dataFilters?.FiltrarPorData === "criacao") {
      setDataFilters({
        ...dataFilters,
        InicioIntervaloAtualizacaoLead: null,
        FimIntervaloAtualizacaoLead: null,
      });
    }
    if (dataFilters?.FiltrarPorData === "atualizacao") {
      setDataFilters({
        ...dataFilters,
        InicioIntervaloCadastroLead: null,
        FimIntervaloCadastroLead: null,
      });
    }
  }, [dataFilters?.FiltrarPorData]);

  useEffect(() => {
    if (dataFilters?.InicioIntervaloAtualizacaoLead) {
      setDataAtualizacaoInicioValida(true);
    } else {
      setDataAtualizacaoInicioValida(false);
    }
  }, [dataFilters?.InicioIntervaloAtualizacaoLead]);

  useEffect(() => {
    if (dataFilters?.InicioIntervaloCadastroLead) {
      setDataCriacaoInicioValida(true);
    } else {
      setDataCriacaoInicioValida(false);
    }
  }, [dataFilters?.InicioIntervaloCadastroLead]);

  useEffect(() => {
    if (
      dataFilters?.FimIntervaloCadastroLead <
      dataFilters?.InicioIntervaloCadastroLead
    ) {
      setErrorDataCadastro(true);
    } else {
      setErrorDataCadastro(false);
    }
  }, [dataFilters?.FimIntervaloCadastroLead]);

  useEffect(() => {
    if (dataFilters.InicioIntervaloCadastroLead !== null) {
      setDataCriacaoInicioValida(true);
    } else {
      setDataCriacaoInicioValida(false);
      setDataFilters({
        ...dataFilters,
        FimIntervaloCadastroLead: null,
      });
    }
  }, [dataFilters.InicioIntervaloCadastroLead]);

  useEffect(() => {
    if (
      dataFilters?.FimIntervaloAtualizacaoLead <
      dataFilters?.InicioIntervaloAtualizacaoLead
    ) {
      setErrorDataAtualizacao(true);
    } else {
      setErrorDataAtualizacao(false);
    }
  }, [dataFilters?.FimIntervaloAtualizacaoLead]);

  const autocompleteRef: any = React.useRef();
  const clearAutocomplete = () => {
    if (autocompleteRef.current) {
      const clearButton = autocompleteRef.current.querySelector(
        ".MuiAutocomplete-clearIndicator"
      );

      if (clearButton) {
        clearButton.click();
      }
    }
  };

  useEffect(() => {
    if (dataFilters?.SemEmpreendimentoInteresse) {
      clearAutocomplete();
      setDisabledProdutoInteresse(true);
      setDataFilters({ ...dataFilters, IdsEmpreendimentos: null });
    } else {
      setDisabledProdutoInteresse(false);
    }
  }, [dataFilters?.SemEmpreendimentoInteresse]);

  useEffect(() => {
    if (
      dataFilters?.FimIntervaloTransferencia <
      dataFilters?.InicioIntervaloTransferencia
    ) {
      setErrorDataRecebidos(true);
    } else {
      setErrorDataRecebidos(false);
    }
  }, [dataFilters?.FimIntervaloTransferencia]);

  const { data: tags } = getEtiquetas();

  const etiquetasData = tags?.etiquetasCorretor?.map(
    (item: { id: string; nome: string; cor: string }) => {
      return {
        value: item?.id,
        label: item?.nome,
        background: item?.cor,
      };
    }
  );

  const { data: dataEtapa, refetch: refetchEtapas } = useGetEtapas();

  const etapasData = dataEtapa
    ? dataEtapa?.map((item: any) => {
        return {
          value: item?.id,
          label: item?.nome,
        };
      })
    : [];

  const {
    data: dataSubEtapa,
    refetch: refetchSubEtapa,
    isFetching: isFetchingSubEtapa,
  } = useGetSubetapas({
    idsEtapas: dataFilters?.Etapas,
    idRegional: idRegionalSistemaOrigem,
    OrigemRequisicao:
      filters?.OrigemRequisicao === OrigemRequisicao.Indicadores
        ? OrigemRequisicao.Indicadores
        : null,
  });

  const statusData = [
    {
      value: 1,
      label: "Atualizado",
    },
    {
      value: 2,
      label: "Desatualizará",
    },
    {
      value: 3,
      label: "Desatualizado",
    },
  ];

  const quartosData = [
    {
      value: "1",
      label: "1",
    },
    {
      value: "2",
      label: "2",
    },
    {
      value: "3",
      label: "3",
    },
    {
      value: "4",
      label: "4+",
    },
  ];

  const {
    data: dataOrigem,
    refetch: refetchOrigem,
    status: statusOrigem,
  } = useListarOrigensLeads({
    filtro: true,
  });

  const {
    data: dataTemperatura,
    refetch: refetchTemperatura,
    status: statusTemperatura,
  } = useTemperaturasLead();

  useEffect(() => {
    if (isOpen && !fetchedFilter) {
      refetchOrigem();
      refetchTemperatura();
      requestRendaFamiliar();
      requestEmpreendimento();
      requestZonas();
      // requestTemperaturas();
      requestTiposEmpreendimentos();
      requestObjetivos();
      requestPrazos();
      setFetchedFilter(true);
      refetchUsuariosPorEquipe();
      refetchUsuariosPorEquipeCorretor();
      refetchMotivosDesqualificacao();
      refetchEtapas();
    }
  }, [isOpen, fetchedFilter]);

  useEffect(() => {
    if (isOpen) {
      refetchEtapas();
    }
  }, [isOpen]);

  useEffect(() => {
    if (
      dataFilters?.IdsZonasEmpreendimentos &&
      dataFilters?.IdsZonasEmpreendimentos !== undefined
    )
      requestBairros();
  }, [dataFilters?.IdsZonasEmpreendimentos]);

  useEffect(() => {
    if (dataFilters?.IdsOrigem && dataFilters?.IdsOrigem.length > 0) {
      const idsOrigem = dataFilters.IdsOrigem.map(
        (item: any) => item?.value ?? item
      );
      requestCanaisContato(idsOrigem);
    } else {
      setCanaisContato([]);
    }
  }, [dataFilters?.IdsOrigem]);

  // const requestOrigin = async () => {
  //   try {
  //     const response = await axiosLead.GetValidOrigin(true);
  //     setOrigens(response.data.data);
  //   } catch (error) {
  //     toast.error("Erro ao listar origens.");
  //   }
  // };

  const requestRendaFamiliar = async () => {
    try {
      const response = await axiosLead.GetRendaFamiliar();
      setRendas(response.data.data);
    } catch (error: any) {
      console.log(
        error?.response?.data?.notifications
          ? error?.response?.data?.notifications?.map(
              (item: any) => `${item.message}\n`
            )
          : "Erro ao listar rendas."
      );
    }
  };

  const requestEmpreendimento = async () => {
    try {
      const response = await axiosLead.GetEnterprises();
      setProdutos(response.data.data);
    } catch (error: any) {
      console.log(
        error?.response?.data?.notifications
          ? error?.response?.data?.notifications?.map(
              (item: any) => `${item.message}\n`
            )
          : "Erro ao listar empreendimentos."
      );
    }
  };

  const requestZonas = async () => {
    try {
      const response = await axiosLead.GetZone();
      const { data } = response.data;

      setZonasData(
        data.map((item: { nome: string; id: string }) => {
          return {
            label: item.nome,
            value: item.id,
          };
        })
      );
    } catch (error) {
      console.log("Erro ao listar zonas.");
    }
  };

  const requestBairros = async () => {
    try {
      const response = await axiosLead.GetDistricts(
        dataFilters?.IdsZonasEmpreendimentos
      );
      const { data } = response.data;

      setBairros(
        data.map((item: { nome: string; idBairro: string }) => {
          return {
            label: item.nome,
            value: item.idBairro,
          };
        })
      );
    } catch (error: any) {
      console.log(
        error?.response?.data?.notifications
          ? error?.response?.data?.notifications?.map(
              (item: any) => `${item.message}\n`
            )
          : "Erro ao listar bairros."
      );
    }
  };
  // const requestTemperaturas = async () => {
  //   try {
  //     const response = await axiosLead.GetTemperature();
  //     const { data } = response.data;
  //     setTemperaturaData(
  //       data.map((item: { nome: string; id: string }) => {
  //         return {
  //           label: item.nome,
  //           value: item.id,
  //         };
  //       })
  //     );
  //   } catch (error: any) {
  //     console.log(
  //       error?.response?.data?.notifications
  //         ? error?.response?.data?.notifications?.map(
  //             (item: any) => `${item.message}\n`
  //           )
  //         : "Erro ao listar temperaturas."
  //     );
  //   }
  // };
  const requestTiposEmpreendimentos = async () => {
    try {
      const response = await axiosLead.GetEnterpriseType();
      const { data } = response.data;
      setEmpreendimentoData(
        data.map((item: { nome: string; id: string }) => {
          return {
            label: item.nome,
            value: item.id,
          };
        })
      );
    } catch (error: any) {
      console.log(
        error?.response?.data?.notifications
          ? error?.response?.data?.notifications?.map(
              (item: any) => `${item.message}\n`
            )
          : "Erro ao listar temperaturas."
      );
    }
  };
  const requestObjetivos = async () => {
    try {
      const response = await axiosLead.GetObjetivosData();
      const { data } = response.data;

      setObjetivosData(
        data.map((item: { nome: string; id: string }) => {
          return {
            label: item.nome,
            value: item.id,
          };
        })
      );
    } catch (error) {
      console.log("Erro ao listar objetivos");
    }
  };
  const requestPrazos = async () => {
    try {
      const response = await axiosLead.GetPrazos();
      const { data } = response.data;

      setPrazosData(
        data.map((item: { nome: string; id: string }) => {
          return {
            label: item.nome,
            value: item.id,
          };
        })
      );
    } catch (error) {
      console.log("Erro ao listar prazos");
    }
  };

  const requestCanaisContato = async (idsOrigem: string[]) => {
    if (!idsOrigem || idsOrigem.length === 0) {
      setCanaisContato([]);
      return [];
    }

    setLoadingCanais(true);
    try {
      const response = await axiosLead.GetCanaisContato(idsOrigem);
      const { data } = response.data;

      const mapped = data.map((item: { nome: string; id: string }) => ({
        label: item.nome,
        value: item.id,
      }));
      setCanaisContato(mapped);
      return mapped;
    } catch (error: any) {
      console.log(
        error?.response?.data?.notifications
          ? error?.response?.data?.notifications?.map(
              (item: any) => `${item.message}\n`
            )
          : "Erro ao listar canais de contato."
      );
      setCanaisContato([]);
      return [];
    } finally {
      setLoadingCanais(false);
    }
  };

  const handleFilters = () => {
    setFilters({
      ...dataFilters,
      showDiretorFilters,
      TipoVisualizacao: filters?.TipoVisualizacao,
      idFiltro: selectedFiltroId || undefined,
      paginationParams: {
        PaginaAtual: 1,
        PalavrasChave: "",
        TotalItensRetorno: getTotalItensRetorno(filters),
        OrdenarPorOrdemAlfabetica: "",
      },
    });
    if (selectedFiltroId) {
      setIsFilterDirty(false);
      savedFiltersSnapshot.current = JSON.stringify(dataFilters);
    }
    setHasFilterChanges(false);
    initialFiltersSnapshot.current = JSON.stringify(dataFilters);
    onApply?.();
  };

  const matchIdsToOptions = (
    ids: string[] | null | undefined,
    options: { label: string; value: string }[]
  ) => {
    if (!ids || ids.length === 0) return [];
    return ids
      .map((id) => options.find((opt) => opt.value === id))
      .filter(Boolean);
  };

  const handleSelectFilter = async (idFiltro: string) => {
    if (idFiltro === "") {
      setSelectedFiltroId("");
      setSelectedFiltroNome("");
      setIsFilterDirty(false);
      savedFiltersSnapshot.current = "";
      return;
    }
    const filtro = filtrosSalvos?.find(
      (f: FiltroSalvo) => f.idFiltro === idFiltro
    );
    if (!filtro) return;

    setSelectedFiltroId(filtro.idFiltro);
    setSelectedFiltroNome(filtro.nomeFiltro);

    // Map boolean → radio string
    const ordenar =
      filtro.ordenarPorRecentes === true
        ? "recentes"
        : filtro.ordenarPorRecentes === false
        ? "antigos"
        : null;

    const identificaCliente =
      filtro.identificaCliente === true
        ? "sim"
        : filtro.identificaCliente === false
        ? "nao"
        : null;

    const visitou =
      filtro.visitou === true ? "sim" : filtro.visitou === false ? "nao" : null;

    // Determine FiltrarPorData radio
    let filtrarPorData = null;
    if (filtro.dataCriacaoInicio || filtro.dataCriacaoFim) {
      filtrarPorData = "criacao";
    } else if (filtro.dataAtualizacaoInicio || filtro.dataAtualizacaoFim) {
      filtrarPorData = "atualizacao";
    }

    // Autocomplete options mapping
    const origemOptions =
      dataOrigem?.data?.map((item: any) => ({
        label: item.nome,
        value: item.id,
      })) || [];

    const rendaOptions = rendas.map((item: any) => ({
      label: item.nome,
      value: item.id,
    }));

    const empreendimentoOptions = produtos.map((item: any) => ({
      label: item.nome,
      value: item.id,
    }));

    const subEtapaOptions = dataSubEtapa
      ? dataSubEtapa?.subEtapas?.map((item: any) => ({
          label: item?.nome,
          value: item?.id,
        }))
      : [];

    // Fetch canais de contato BEFORE building dataFilters
    let canaisOptions: any[] = [];
    if (filtro.idsOrigem && filtro.idsOrigem.length > 0) {
      canaisOptions = await requestCanaisContato(filtro.idsOrigem);
    }

    const newDataFilters = {
      OrdenarPorRecentes: ordenar,
      IdentificaCliente: identificaCliente,
      Visitou: visitou,
      FiltrarPorData: filtrarPorData,
      InicioIntervaloCadastroLead: filtro.dataCriacaoInicio || null,
      FimIntervaloCadastroLead: filtro.dataCriacaoFim || null,
      InicioIntervaloAtualizacaoLead: filtro.dataAtualizacaoInicio || null,
      FimIntervaloAtualizacaoLead: filtro.dataAtualizacaoFim || null,
      FiltrarRecebidosPorTransferencia:
        filtro.recebidosPorTransferencia || null,
      InicioIntervaloTransferencia: filtro.dataTransferenciaInicio || null,
      FimIntervaloTransferencia: filtro.dataTransferenciaFim || null,
      // Autocomplete fields (need {label, value} objects)
      IdsOrigem: matchIdsToOptions(filtro.idsOrigem, origemOptions),
      IdsCanalContato: matchIdsToOptions(filtro.idsCanalContato, canaisOptions),
      IdsRendaFamiliares: matchIdsToOptions(
        filtro.idsRendaFamiliares,
        rendaOptions
      ),
      IdsEmpreendimentos: matchIdsToOptions(
        filtro.idsEmpreendimentos,
        empreendimentoOptions
      ),
      IdsBairrosEmpreendimentos:
        bairros.length > 0
          ? matchIdsToOptions(filtro.idsBairrosEmpreendimentos, bairros)
          : filtro.idsBairrosEmpreendimentos || [],
      IdSubEtapaFunil365:
        subEtapaOptions.length > 0
          ? matchIdsToOptions(filtro.idsSubetapas, subEtapaOptions)
          : filtro.idsSubetapas || [],
      IdMotivoDesqualificacaoLead365: matchIdsToOptions(
        filtro.idsMotivosDesqualificacao,
        transformedListMotivos
      ),
      IdsEquipes: matchIdsToOptions(
        filtro.idsEquipes,
        transformedListIdsEquipes
      ),
      IdsCorretores: matchIdsToOptions(
        filtro.idsCorretores,
        transformedListCorretorResponsavel
      ),
      // ToggleBtns fields (raw arrays)
      Etapas: filtro.idsEtapas || undefined,
      IdsEtiquetas: filtro.idsEtiquetas || undefined,
      Status: filtro.farois || undefined,
      IdsTemperaturasLead: filtro.idsTemperaturasLead || undefined,
      IdsTipoEmpreendimentos: filtro.idsTipoEmpreendimentos || undefined,
      QuantidadesDormitorios:
        filtro.quantidadesDormitorios?.map((v: number) => String(v)) ||
        undefined,
      IdsZonasEmpreendimentos: filtro.idsZonasEmpreendimentos || undefined,
      IdsObjetivosCompra: filtro.idsObjetivosCompra || undefined,
      IdsPrazosEntrega: filtro.idsPrazosEntrega || undefined,
      // Values
      InicioIntervaloValorImovel: filtro.valorImovelInicio ?? "",
      FimIntervaloValorImovel: filtro.valorImovelFim ?? "",
      // Booleans
      SemEmpreendimentoInteresse: filtro.semEmpreendimentoInteresse || false,
      LeadsDesqualificados: filtro.somenteLeadsBolsao || false,
    };

    setDataFilters(newDataFilters);
    setIsFilterDirty(false);
    savedFiltersSnapshot.current = JSON.stringify(newDataFilters);
  };

  const buildFiltrosObject = () => {
    const df = dataFilters;
    const extractVals = (arr: any[] | undefined) => {
      if (!arr || arr.length === 0) return undefined;
      return arr.map((item: any) => item?.value ?? item);
    };
    const filtros: Record<string, any> = {};
    if (df.OrdenarPorRecentes === "recentes") {
      filtros.ordenarPorRecentes = true;
    } else if (df.OrdenarPorRecentes === "antigos") {
      filtros.ordenarPorRecentes = false;
    }
    if (df.InicioIntervaloCadastroLead) {
      filtros.inicioIntervaloCadastroLead = df.InicioIntervaloCadastroLead;
    }
    if (df.FimIntervaloCadastroLead) {
      filtros.fimIntervaloCadastroLead = df.FimIntervaloCadastroLead;
    }
    if (df.InicioIntervaloAtualizacaoLead) {
      filtros.inicioIntervaloAtualizacaoLead =
        df.InicioIntervaloAtualizacaoLead;
    }
    if (df.FimIntervaloAtualizacaoLead) {
      filtros.fimIntervaloAtualizacaoLead = df.FimIntervaloAtualizacaoLead;
    }
    if (df.FiltrarRecebidosPorTransferencia != null) {
      filtros.filtrarRecebidosPorTransferencia =
        df.FiltrarRecebidosPorTransferencia;
    }
    if (df.InicioIntervaloTransferencia) {
      filtros.inicioIntervaloTransferencia = df.InicioIntervaloTransferencia;
    }
    if (df.FimIntervaloTransferencia) {
      filtros.fimIntervaloTransferencia = df.FimIntervaloTransferencia;
    }
    if (df.IdentificaCliente === "sim") {
      filtros.identificaCliente = true;
    } else if (df.IdentificaCliente === "nao") {
      filtros.identificaCliente = false;
    }
    if (df.Visitou === "sim") {
      filtros.visitou = true;
    } else if (df.Visitou === "nao") {
      filtros.visitou = false;
    }
    const idsOrigem = extractVals(df.IdsOrigem);
    if (idsOrigem) filtros.idsOrigem = idsOrigem;
    const idsCanalContato = extractVals(df.IdsCanalContato);
    if (idsCanalContato) filtros.idsCanalContato = idsCanalContato;
    if (df.Etapas?.length) filtros.etapas = df.Etapas;
    const idsSub = extractVals(df.IdSubEtapaFunil365);
    if (idsSub) filtros.idSubEtapaFunil365 = idsSub;
    if (df.IdsEtiquetas?.length) filtros.idsEtiquetas = df.IdsEtiquetas;
    if (df.Status?.length) filtros.status = df.Status;
    if (df.IdsTemperaturasLead?.length) {
      filtros.idsTemperaturasLead = df.IdsTemperaturasLead;
    }
    const idsRenda = extractVals(df.IdsRendaFamiliares);
    if (idsRenda) filtros.idsRendaFamiliares = idsRenda;
    const idsEmp = extractVals(df.IdsEmpreendimentos);
    if (idsEmp) filtros.idsEmpreendimentos = idsEmp;
    if (df.SemEmpreendimentoInteresse) {
      filtros.semEmpreendimentoInteresse = true;
    }
    if (df.IdsTipoEmpreendimentos?.length) {
      filtros.idsTipoEmpreendimentos = df.IdsTipoEmpreendimentos;
    }
    if (df.QuantidadesDormitorios?.length) {
      filtros.quantidadesDormitorios = df.QuantidadesDormitorios;
    }
    if (df.IdsZonasEmpreendimentos?.length) {
      filtros.idsZonasEmpreendimentos = df.IdsZonasEmpreendimentos;
    }
    const idsBairros = extractVals(df.IdsBairrosEmpreendimentos);
    if (idsBairros) filtros.idsBairrosEmpreendimentos = idsBairros;
    if (df.InicioIntervaloValorImovel) {
      filtros.inicioIntervaloValorImovel = df.InicioIntervaloValorImovel;
    }
    if (df.FimIntervaloValorImovel) {
      filtros.fimIntervaloValorImovel = df.FimIntervaloValorImovel;
    }
    if (df.IdsObjetivosCompra?.length) {
      filtros.idsObjetivosCompra = df.IdsObjetivosCompra;
    }
    if (df.IdsPrazosEntrega?.length) {
      filtros.idsPrazosEntrega = df.IdsPrazosEntrega;
    }
    const idsMotivos = extractVals(df.IdMotivoDesqualificacaoLead365);
    if (idsMotivos) filtros.idMotivoDesqualificacaoLead365 = idsMotivos;
    if (df.LeadsDesqualificados) filtros.leadsDesqualificados = true;
    const idsEquipes = extractVals(df.IdsEquipes);
    if (idsEquipes) filtros.idsEquipes = idsEquipes;
    const idsCorretores = extractVals(df.IdsCorretores);
    if (idsCorretores) filtros.idsCorretores = idsCorretores;
    return filtros;
  };

  const handleCreateFilter = async () => {
    if (!newFilterName.trim()) return;
    try {
      const nome = newFilterName.trim();
      const filtros = buildFiltrosObject();
      const body: Record<string, any> = { nomeFiltro: nome };
      if (selectedFiltroId) {
        body.idFiltro = selectedFiltroId;
      }
      if (Object.keys(filtros).length > 0) {
        body.filtros = filtros;
      }
      await criarFiltro.mutateAsync(body);
      toast.success("Filtro salvo com sucesso!");
      setNewFilterName("");
      setShowSaveForm(false);
      const refreshed = await refetchFiltrosSalvos();
      const newFiltro = refreshed?.data?.find(
        (f: FiltroSalvo) => f.nomeFiltro === nome
      );
      if (newFiltro) {
        setSelectedFiltroId(newFiltro.idFiltro);
        setSelectedFiltroNome(newFiltro.nomeFiltro);
        setIsFilterDirty(false);
        savedFiltersSnapshot.current = JSON.stringify(dataFilters);
      }
    } catch {
      // error handled by mutation hook
    }
  };

  const isPrimitiveArray = (arr: any) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    (typeof arr[0] === "string" || typeof arr[0] === "number");

  useEffect(() => {
    if (!isPrimitiveArray(dataFilters?.IdsCanalContato)) return;
    if (!Array.isArray(canaisContato) || canaisContato.length === 0) return;

    setDataFilters((prev: any) => ({
      ...prev,
      IdsCanalContato: matchIdsToOptions(prev.IdsCanalContato, canaisContato),
    }));
  }, [canaisContato, dataFilters?.IdsCanalContato]);

  useEffect(() => {
    if (!isPrimitiveArray(dataFilters?.IdsBairrosEmpreendimentos)) return;
    if (!Array.isArray(bairros) || bairros.length === 0) return;

    setDataFilters((prev: any) => ({
      ...prev,
      IdsBairrosEmpreendimentos: matchIdsToOptions(
        prev.IdsBairrosEmpreendimentos,
        bairros
      ),
    }));
  }, [bairros, dataFilters?.IdsBairrosEmpreendimentos]);

  useEffect(() => {
    if (!isPrimitiveArray(dataFilters?.IdsOrigem)) return;

    const origemOptions =
      dataOrigem?.data?.map((item: any) => ({
        label: item.nome,
        value: item.id,
      })) || [];

    if (origemOptions.length === 0) return;

    setDataFilters((prev: any) => ({
      ...prev,
      IdsOrigem: matchIdsToOptions(prev.IdsOrigem, origemOptions),
    }));
  }, [dataOrigem, dataFilters?.IdsOrigem]);

  const handleDeleteFilter = async () => {
    if (!confirmDeleteId) return;
    try {
      await excluirFiltro.mutateAsync(confirmDeleteId);
      toast.success("Filtro excluído com sucesso!");
      if (selectedFiltroId === confirmDeleteId) {
        setSelectedFiltroId("");
        setSelectedFiltroNome("");
        setIsFilterDirty(false);
        savedFiltersSnapshot.current = "";
      }
      setConfirmDeleteId(null);
      setConfirmDeleteNome("");
      await refetchFiltrosSalvos();
    } catch {
      // error handled by mutation hook
    }
  };

  const handleRenameFilter = async () => {
    if (!renameFilterName.trim() || !selectedFiltroId) return;
    try {
      await criarFiltro.mutateAsync({
        idFiltro: selectedFiltroId,
        nomeFiltro: renameFilterName.trim(),
      });
      toast.success("Filtro renomeado com sucesso!");
      setSelectedFiltroNome(renameFilterName.trim());
      setShowRenameForm(false);
      setRenameFilterName("");
      await refetchFiltrosSalvos();
    } catch {
      // error handled by mutation hook
    }
  };

  // Dirty detection: when dataFilters change and a filter is selected
  useEffect(() => {
    if (selectedFiltroId && savedFiltersSnapshot.current) {
      const current = JSON.stringify(dataFilters);
      setIsFilterDirty(current !== savedFiltersSnapshot.current);
    }
  }, [dataFilters, selectedFiltroId]);

  // Track any filter changes from initial state
  useEffect(() => {
    if (initialFiltersSnapshot.current) {
      const current = JSON.stringify(dataFilters);
      setHasFilterChanges(current !== initialFiltersSnapshot.current);
    }
  }, [dataFilters]);
  const {
    data: dataUsuariosPorEquipe,
    refetch: refetchUsuariosPorEquipe,
    isSuccess: isSuccessUsuariosPorEquipe,
  } = useListarUsuariosPorEquipe({
    queryKey: "listar-usuarios-por-equipe",
  });
  const {
    data: dataMotivosDesqualificacao,
    refetch: refetchMotivosDesqualificacao,
    isSuccess: isSuccessMotivosDesqualificacao,
  } = useMotivosDesquealificacao({
    queryKey: "listar-motivos-desqualificacao",
  });

  const valuesArray: string[] = dataFilters?.IdsUsuarioLider?.map(
    (item: any) => item.value
  );
  const {
    data: dataUsuariosPorEquipeCorretor,
    refetch: refetchUsuariosPorEquipeCorretor,
    isSuccess: isSuccessUsuariosPorEquipeCorretor,
    isRefetching: isRefetchingUsuariosPorEquipeCorretor,
  } = useListarUsuariosPorEquipe({
    queryKey: "listar-usuarios-por-equipe-corretor",
    IdsUsuarioLider: valuesArray ?? [],
  });

  const transformedList = useTransformList({
    inputList: dataUsuariosPorEquipe?.data,
    labelField: "apelido",
    valueField: "idUsuario",
  });
  const transformedListIdsEquipes =
    dataUsuariosPorEquipe?.data
      ?.map((item: any) => ({
        label: item?.apelido,
        value: item?.idEquipeLiderUsuario ?? item?.idEquipe,
      }))
      ?.filter((item: any) => item?.value) || [];

  const transformedListMotivos = useTransformList({
    inputList: dataMotivosDesqualificacao?.data,
    labelField: "nome",
    valueField: "id",
  });

  const transformedListCorretorResponsavel = useTransformList({
    inputList: dataUsuariosPorEquipeCorretor?.data,
    labelField: "apelido",
    valueField: "idCorretor",
  });

  const handleCleanFilters = () => {
    const ACBtns = document.querySelectorAll(".MuiAutocomplete-clearIndicator");
    if (ACBtns) {
      ACBtns.forEach((el: any) => el.click());
    }
    setFilterButtonDisabled(false);
    setSelectedFiltroId("");
    setSelectedFiltroNome("");
    setIsFilterDirty(false);
    setHasFilterChanges(false);
    setShowSaveForm(false);
    setNewFilterName("");
    savedFiltersSnapshot.current = "";
    const cleanState = {
      OrdenarPorRecentes: null,
      IdentificaCliente: null,
      Visitou: null,
      InicioIntervaloCadastroLead: null,
      FimIntervaloCadastroLead: null,
      InicioIntervaloAtualizacaoLead: null,
      FimIntervaloAtualizacaoLead: null,
      InicioIntervaloTransferencia: null,
      FimIntervaloTransferencia: null,
      FiltrarRecebidosPorTransferencia: null,
      InicioIntervaloValorImovel: "",
      FimIntervaloValorImovel: "",
      SemEmpreendimentoInteresse: false,
      LeadsDesqualificados: false,
      paginationParams: {
        PaginaAtual: 1,
        PalavrasChave: "",
        TotalItensRetorno: getTotalItensRetorno(filters),
        OrdenarPorOrdemAlfabetica: "",
      },
    };
    setDataFilters(cleanState);
    initialFiltersSnapshot.current = JSON.stringify(cleanState);
  };

  useEffect(() => {
    if (!isPrimitiveArray(dataFilters?.IdMotivoDesqualificacaoLead365)) return;
    if (
      !Array.isArray(transformedListMotivos) ||
      transformedListMotivos.length === 0
    )
      return;

    setDataFilters((prev: any) => ({
      ...prev,
      IdMotivoDesqualificacaoLead365: matchIdsToOptions(
        prev.IdMotivoDesqualificacaoLead365,
        transformedListMotivos
      ),
    }));
  }, [transformedListMotivos, dataFilters?.IdMotivoDesqualificacaoLead365]);

  useEffect(() => {
    if (!isPrimitiveArray(dataFilters?.IdsEquipes)) return;
    if (
      !Array.isArray(transformedListIdsEquipes) ||
      transformedListIdsEquipes.length === 0
    )
      return;

    setDataFilters((prev: any) => ({
      ...prev,
      IdsEquipes: matchIdsToOptions(prev.IdsEquipes, transformedListIdsEquipes),
    }));
  }, [transformedListIdsEquipes, dataFilters?.IdsEquipes]);

  useEffect(() => {
    if (!isPrimitiveArray(dataFilters?.IdsCorretores)) return;
    if (
      !Array.isArray(transformedListCorretorResponsavel) ||
      transformedListCorretorResponsavel.length === 0
    )
      return;

    setDataFilters((prev: any) => ({
      ...prev,
      IdsCorretores: matchIdsToOptions(
        prev.IdsCorretores,
        transformedListCorretorResponsavel
      ),
    }));
  }, [transformedListCorretorResponsavel, dataFilters?.IdsCorretores]);

  useEffect(() => {
    if (!isPrimitiveArray(dataFilters?.IdsRendaFamiliares)) return;
    if (!Array.isArray(rendas) || rendas.length === 0) return;

    const rendaOptions = rendas.map((r: any) => ({
      label: r.nome,
      value: r.id,
    }));

    setDataFilters((prev: any) => ({
      ...prev,
      IdsRendaFamiliares: matchIdsToOptions(
        prev.IdsRendaFamiliares,
        rendaOptions
      ),
    }));
  }, [rendas, dataFilters?.IdsRendaFamiliares]);

  useEffect(() => {
    if (!isPrimitiveArray(dataFilters?.IdsEmpreendimentos)) return;
    if (!Array.isArray(produtos) || produtos.length === 0) return;

    const empreendimentoOptions = produtos.map((item: any) => ({
      label: item.nome,
      value: item.id,
    }));

    setDataFilters((prev: any) => ({
      ...prev,
      IdsEmpreendimentos: matchIdsToOptions(
        prev.IdsEmpreendimentos,
        empreendimentoOptions
      ),
    }));
  }, [produtos, dataFilters?.IdsEmpreendimentos]);

  useEffect(() => {
    if (!isPrimitiveArray(dataFilters?.IdSubEtapaFunil365)) return;

    const subEtapaOptions =
      dataSubEtapa?.subEtapas?.map((s: any) => ({
        label: s.nome,
        value: s.id,
      })) || [];

    if (subEtapaOptions.length === 0) return;

    setDataFilters((prev: any) => ({
      ...prev,
      IdSubEtapaFunil365: matchIdsToOptions(
        prev.IdSubEtapaFunil365,
        subEtapaOptions
      ),
    }));
  }, [dataSubEtapa, dataFilters?.IdSubEtapaFunil365]);

  useEffect(() => {
    if (dataFilters?.Etapas?.length) {
      refetchSubEtapa();
    }
  }, [JSON.stringify(dataFilters?.Etapas)]);

  useEffect(() => {
    const loaded = {
      OrdenarPorRecentes: filters?.OrdenarPorRecentes,
      IdentificaCliente: filters?.IdentificaCliente,
      Visitou: filters?.Visitou,
      FiltrarRecebidosPorTransferencia:
        filters?.FiltrarRecebidosPorTransferencia,
      InicioIntervaloTransferencia: filters?.InicioIntervaloTransferencia,
      FimIntervaloTransferencia: filters?.FimIntervaloTransferencia,
      InicioIntervaloCadastroLead: filters?.InicioIntervaloCadastroLead,
      FimIntervaloCadastroLead: filters?.FimIntervaloCadastroLead,
      FiltrarPorData: filters?.FiltrarPorData,
      InicioIntervaloAtualizacaoLead: filters?.InicioIntervaloAtualizacaoLead,
      FimIntervaloAtualizacaoLead: filters?.FimIntervaloAtualizacaoLead,
      IdsOrigem: filters?.IdsOrigem,
      IdsEquipes: filters?.IdsEquipes,
      IdsUsuarioLider: filters?.IdsUsuarioLider,
      IdMotivoDesqualificacaoLead365: filters?.IdMotivoDesqualificacaoLead365,
      IdsCorretores: filters?.IdsCorretores,
      SuperintendenteSelecionado: filters?.SuperintendenteSelecionado,
      EquipeSelecionada: filters?.EquipeSelecionada,
      CorretorSelecionado: filters?.CorretorSelecionado,
      showDiretorFilters: filters?.showDiretorFilters,
      Etapas: filters?.Etapas,
      IdSubEtapaFunil365: filters?.IdSubEtapaFunil365,
      IdsEtiquetas: filters?.IdsEtiquetas,
      Status: filters?.Status,
      IdsTemperaturasLead: filters?.IdsTemperaturasLead,
      IdsRendaFamiliares: filters?.IdsRendaFamiliares,
      IdsEmpreendimentos: filters?.IdsEmpreendimentos,
      IdsTipoEmpreendimentos: filters?.IdsTipoEmpreendimentos,
      QuantidadesDormitorios: filters?.QuantidadesDormitorios,
      IdsZonasEmpreendimentos: filters?.IdsZonasEmpreendimentos,
      IdsBairrosEmpreendimentos: filters?.IdsBairrosEmpreendimentos,
      InicioIntervaloValorImovel: filters?.InicioIntervaloValorImovel,
      FimIntervaloValorImovel: filters?.FimIntervaloValorImovel,
      IdsObjetivosCompra: filters?.IdsObjetivosCompra,
      IdsPrazosEntrega: filters?.IdsPrazosEntrega,
      SemEmpreendimentoInteresse: filters?.SemEmpreendimentoInteresse,
      LeadsDesqualificados: filters?.LeadsDesqualificados,
      IdsCanalContato: filters?.IdsCanalContato,
    };
    setDataFilters(loaded);
    initialFiltersSnapshot.current = JSON.stringify(loaded);
  }, []);

  useEffect(() => {
    if (!filters?.idFiltro) return;
    if (!Array.isArray(filtrosSalvos) || filtrosSalvos.length === 0) return;
    if (selectedFiltroId) return;

    const filtro = filtrosSalvos.find(
      (f: FiltroSalvo) => f.idFiltro === filters.idFiltro
    );
    if (filtro) {
      setSelectedFiltroId(filtro.idFiltro);
      setSelectedFiltroNome(filtro.nomeFiltro);
      savedFiltersSnapshot.current = JSON.stringify(dataFilters);
    }
  }, [filtrosSalvos, filters?.idFiltro]);

  // React.useEffect(() => {
  //   refetchUsuariosPorEquipe();
  //   refetchUsuariosPorEquipeCorretor();
  //   refetchMotivosDesqualificacao();
  // }, []);

  return (
    <>
      <Styles.HeaderModal>
        <IconsSVG.FilterModalIcon />
        <Styles.HeaderModalTitle>Filtros</Styles.HeaderModalTitle>
        <Styles.ClearBtn onClick={handleCleanFilters}>Limpar</Styles.ClearBtn>
      </Styles.HeaderModal>
      <Styles.ContentModal>
        {/* Filtros Salvos */}
        <Styles.SavedFilterRow>
          <Styles.SavedFilterLabel>Filtros Salvos</Styles.SavedFilterLabel>
          {selectedFiltroId && (
            <Styles.EditFilterBtn
              type="button"
              onClick={() => {
                setShowRenameForm((prev) => !prev);
                setRenameFilterName(selectedFiltroNome);
              }}
            >
              <FiEdit2 size={15} />
            </Styles.EditFilterBtn>
          )}
          {selectedFiltroId && (
            <Styles.DeleteFilterBtn
              type="button"
              onClick={() => {
                setConfirmDeleteId(selectedFiltroId);
                setConfirmDeleteNome(selectedFiltroNome);
              }}
            >
              <FiTrash2 size={16} />
            </Styles.DeleteFilterBtn>
          )}
          {selectedFiltroId && isFilterDirty && (
            <Styles.EditedBadge>EDITADO</Styles.EditedBadge>
          )}
        </Styles.SavedFilterRow>
        <SelectAutoCompleteG
          data={
            Array.isArray(filtrosSalvos)
              ? filtrosSalvos.map((f) => ({
                  label: f.nomeFiltro,
                  value: f.idFiltro,
                }))
              : []
          }
          value={
            selectedFiltroId
              ? {
                  label: selectedFiltroNome,
                  value: selectedFiltroId,
                }
              : null
          }
          onChange={(val: any) => {
            handleSelectFilter(val?.value || "");
          }}
          placeholder="Selecione um filtro"
        />
        {showRenameForm && (
          <Styles.SaveFilterForm>
            <InputComponent
              placeholder="Novo nome do filtro..."
              value={renameFilterName}
              onChange={(e: any) => setRenameFilterName(e.target.value)}
            />
            <Styles.SaveFilterActions>
              <Styles.CancelFilterBtn
                type="button"
                onClick={() => {
                  setShowRenameForm(false);
                  setRenameFilterName("");
                }}
              >
                Cancelar
              </Styles.CancelFilterBtn>
              <Styles.SaveFilterBtn
                type="button"
                disabled={!renameFilterName.trim() || criarFiltro.isLoading}
                onClick={handleRenameFilter}
              >
                Renomear
              </Styles.SaveFilterBtn>
            </Styles.SaveFilterActions>
          </Styles.SaveFilterForm>
        )}
        {!showSaveForm && !showRenameForm && hasFilterChanges && (
          <Styles.SaveNewFilterLink
            onClick={() => {
              setShowSaveForm(true);
              setNewFilterName(
                selectedFiltroNome ? `${selectedFiltroNome} (cópia)` : ""
              );
            }}
          >
            + Salvar como novo filtro
          </Styles.SaveNewFilterLink>
        )}
        {showSaveForm && (
          <Styles.SaveFilterForm>
            <InputComponent
              placeholder="Nome do filtro..."
              value={newFilterName}
              onChange={(e: any) => setNewFilterName(e.target.value)}
            />
            <Styles.SaveFilterActions>
              <Styles.CancelFilterBtn
                type="button"
                onClick={() => {
                  setShowSaveForm(false);
                  setNewFilterName("");
                }}
              >
                Cancelar
              </Styles.CancelFilterBtn>
              <Styles.SaveFilterBtn
                type="button"
                disabled={!newFilterName.trim() || criarFiltro.isLoading}
                onClick={handleCreateFilter}
              >
                Salvar
              </Styles.SaveFilterBtn>
            </Styles.SaveFilterActions>
          </Styles.SaveFilterForm>
        )}
        <Styles.SpaceY space={24} />
        <Styles.LabelModal>Ordenar por</Styles.LabelModal>
        <Styles.RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          // @ts-ignore
          defaultValue={filters?.OrdenarPorRecentes || null}
          name="radio-buttons-group"
          onChange={(e) =>
            setDataFilters({
              ...dataFilters,
              OrdenarPorRecentes: e.target.value,
            })
          }
        >
          <Styles.FormControlLabel
            value="recentes"
            control={
              <Styles.Radio
                checked={dataFilters?.OrdenarPorRecentes === "recentes"}
                onClick={() =>
                  dataFilters?.OrdenarPorRecentes === "recentes" &&
                  setDataFilters({ ...dataFilters, OrdenarPorRecentes: null })
                }
              />
            }
            label="Recentes"
          />
          <Styles.FormControlLabel
            value="antigos"
            control={
              <Styles.Radio
                checked={dataFilters?.OrdenarPorRecentes === "antigos"}
                onClick={() =>
                  dataFilters?.OrdenarPorRecentes === "antigos" &&
                  setDataFilters({ ...dataFilters, OrdenarPorRecentes: null })
                }
              />
            }
            label="Antigos"
          />
        </Styles.RadioGroup>
        <Styles.SpaceY space={16} />
        <Styles.LabelModal>Filtrar por</Styles.LabelModal>
        <Styles.RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          // @ts-ignore
          defaultValue={filters?.FiltrarPorData || null}
          name="radio-buttons-group"
          onChange={(e) =>
            setDataFilters({
              ...dataFilters,
              FiltrarPorData: e.target.value,
            })
          }
        >
          <Styles.FormControlLabel
            value="criacao"
            control={
              <Styles.Radio
                checked={dataFilters?.FiltrarPorData === "criacao"}
                onClick={() =>
                  dataFilters?.FiltrarPorData === "criacao" &&
                  setDataFilters({ ...dataFilters, FiltrarPorData: null })
                }
              />
            }
            label="Data criação"
          />
          <Styles.FormControlLabel
            value="atualizacao"
            control={
              <Styles.Radio
                checked={dataFilters?.FiltrarPorData === "atualizacao"}
                onClick={() =>
                  dataFilters?.FiltrarPorData === "atualizacao" &&
                  setDataFilters({ ...dataFilters, FiltrarPorData: null })
                }
              />
            }
            label="Data atualização"
          />
        </Styles.RadioGroup>
        {dataFilters?.FiltrarPorData === "criacao" && (
          <Styles.LocalizationProvider
            locale={ptBR}
            dateAdapter={MaterialUI.AdapterDateFns}
          >
            <Styles.Row>
              <Styles.ContentDate>
                <Styles.DesktopDatePicker
                  inputFormat="dd/MM/yyyy"
                  value={dataFilters?.InicioIntervaloCadastroLead}
                  components={{
                    OpenPickerIcon: IconsSVG.CalendarIcon,
                  }}
                  InputAdornmentProps={{ position: "start" }}
                  onChange={(newValue: any) =>
                    setDataFilters({
                      ...dataFilters,
                      InicioIntervaloCadastroLead: newValue,
                    })
                  }
                  renderInput={(params: any) => (
                    <>
                      <Styles.LabelText>De</Styles.LabelText>
                      <Styles.TextField
                        size="small"
                        InputLabelProps={{ shrink: false }}
                        variant="outlined"
                        {...params}
                        label="De"
                        fullWidth
                      />
                    </>
                  )}
                />
              </Styles.ContentDate>
              <Styles.ContentDate>
                <Styles.DesktopDatePicker
                  disabled={!dataCriacaoInicioValida}
                  inputFormat="dd/MM/yyyy"
                  value={dataFilters?.FimIntervaloCadastroLead}
                  components={{
                    OpenPickerIcon: IconsSVG.CalendarIcon,
                  }}
                  InputAdornmentProps={{ position: "start" }}
                  onChange={(newValue: any) =>
                    setDataFilters({
                      ...dataFilters,
                      FimIntervaloCadastroLead: newValue,
                    })
                  }
                  minDate={dataFilters?.InicioIntervaloCadastroLead}
                  renderInput={(params: any) => (
                    <>
                      <Styles.LabelText>Até</Styles.LabelText>
                      <Styles.TextField
                        size="small"
                        InputLabelProps={{ shrink: false }}
                        variant="outlined"
                        {...params}
                        label="Até"
                        fullWidth
                        error={errorDataCadastro}
                        helperText={
                          dataCriacaoInicioValida && errorDataCadastro
                            ? "Data inválida"
                            : ""
                        }
                      />
                    </>
                  )}
                />
              </Styles.ContentDate>
            </Styles.Row>
          </Styles.LocalizationProvider>
        )}
        {dataFilters?.FiltrarPorData === "atualizacao" && (
          <Styles.LocalizationProvider
            locale={ptBR}
            dateAdapter={MaterialUI.AdapterDateFns}
          >
            <Styles.Row>
              <Styles.ContentDate>
                <Styles.DesktopDatePicker
                  inputFormat="dd/MM/yyyy"
                  value={dataFilters?.InicioIntervaloAtualizacaoLead}
                  components={{
                    OpenPickerIcon: IconsSVG.CalendarIcon,
                  }}
                  InputAdornmentProps={{ position: "start" }}
                  onChange={(newValue: any) =>
                    setDataFilters({
                      ...dataFilters,
                      InicioIntervaloAtualizacaoLead: newValue,
                    })
                  }
                  renderInput={(params: any) => (
                    <>
                      <Styles.LabelText>De</Styles.LabelText>
                      <Styles.TextField
                        size="small"
                        InputLabelProps={{ shrink: false }}
                        variant="outlined"
                        {...params}
                        label="De"
                        fullWidth
                      />
                    </>
                  )}
                />
              </Styles.ContentDate>
              <Styles.ContentDate>
                <Styles.DesktopDatePicker
                  disabled={!dataAtualizacaoInicioValida}
                  inputFormat="dd/MM/yyyy"
                  value={dataFilters?.FimIntervaloAtualizacaoLead}
                  components={{
                    OpenPickerIcon: IconsSVG.CalendarIcon,
                  }}
                  InputAdornmentProps={{ position: "start" }}
                  onChange={(newValue: any) =>
                    setDataFilters({
                      ...dataFilters,
                      FimIntervaloAtualizacaoLead: newValue,
                    })
                  }
                  minDate={dataFilters?.InicioIntervaloAtualizacaoLead}
                  renderInput={(params: any) => (
                    <>
                      <Styles.LabelText>Até</Styles.LabelText>
                      <Styles.TextField
                        size="small"
                        InputLabelProps={{ shrink: false }}
                        variant="outlined"
                        {...params}
                        label="Até"
                        fullWidth
                        error={errorDataAtualizacao}
                        helperText={
                          dataAtualizacaoInicioValida && errorDataAtualizacao
                            ? "Data inválida"
                            : ""
                        }
                      />
                    </>
                  )}
                />
              </Styles.ContentDate>
            </Styles.Row>
          </Styles.LocalizationProvider>
        )}
        <Styles.FormControlLabel
          className="switch-control"
          control={
            <Styles.Switch
              checked={dataFilters?.FiltrarRecebidosPorTransferencia}
              onChange={(e) =>
                setDataFilters({
                  ...dataFilters,
                  FiltrarRecebidosPorTransferencia: e.target.checked,
                })
              }
            />
          }
          labelPlacement="start"
          label="Visualizar apenas leads recebidos"
        />
        <Styles.LocalizationProvider
          locale={ptBR}
          dateAdapter={MaterialUI.AdapterDateFns}
        >
          <Styles.Row>
            <Styles.ContentDate>
              <Styles.DesktopDatePicker
                inputFormat="dd/MM/yyyy"
                value={dataFilters?.InicioIntervaloTransferencia}
                components={{
                  OpenPickerIcon: IconsSVG.CalendarIcon,
                }}
                disabled={!dataFilters?.FiltrarRecebidosPorTransferencia}
                InputAdornmentProps={{ position: "start" }}
                onChange={(newValue: any) =>
                  setDataFilters({
                    ...dataFilters,
                    InicioIntervaloTransferencia: newValue,
                  })
                }
                renderInput={(params: any) => (
                  <>
                    <Styles.LabelText>De</Styles.LabelText>
                    <Styles.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      {...params}
                      label="De"
                      fullWidth
                    />
                  </>
                )}
              />
            </Styles.ContentDate>
            <Styles.ContentDate>
              <Styles.DesktopDatePicker
                inputFormat="dd/MM/yyyy"
                value={dataFilters?.FimIntervaloTransferencia}
                disabled={!dataFilters?.FiltrarRecebidosPorTransferencia}
                components={{
                  OpenPickerIcon: IconsSVG.CalendarIcon,
                }}
                InputAdornmentProps={{ position: "start" }}
                onChange={(newValue: any) =>
                  setDataFilters({
                    ...dataFilters,
                    FimIntervaloTransferencia: newValue,
                  })
                }
                minDate={dataFilters?.InicioIntervaloTransferencia}
                renderInput={(params: any) => (
                  <>
                    <Styles.LabelText>Até</Styles.LabelText>
                    <Styles.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      {...params}
                      label="Até"
                      fullWidth
                      error={errorDataRecebidos}
                      helperText={errorDataRecebidos ? "Data inválida" : ""}
                    />
                  </>
                )}
              />
            </Styles.ContentDate>
          </Styles.Row>
        </Styles.LocalizationProvider>
        <RenderByCargo
          cargo={codigoCargo2013}
          isGerenteVendas={
            <>
              <Styles.LabelText style={{ marginTop: 12 }}>
                Motivos Desqualificação
              </Styles.LabelText>
            </>
          }
          isSuperintendente={
            <>
              <Styles.LabelText style={{ marginTop: 12 }}>
                Motivos Desqualificação
              </Styles.LabelText>
            </>
          }
        />
        {isSuccessMotivosDesqualificacao &&
        dataMotivosDesqualificacao?.data?.length > 0 ? (
          <>
            <RenderByCargo
              cargo={codigoCargo2013}
              isSuperintendente={<></>}
              isGerenteVendas={
                <>
                  <Styles.Autocomplete
                    fullWidth
                    multiple
                    options={transformedListMotivos}
                    size="small"
                    disableCloseOnSelect
                    getOptionLabel={(option: any) => option.label || ""}
                    // @ts-ignore
                    getOptionSelected={(option: any, value: any) =>
                      option.label === value.label
                    }
                    value={dataFilters?.IdMotivoDesqualificacaoLead365 || []}
                    defaultValue={filters?.IdMotivoDesqualificacaoLead365 || []}
                    // @ts-ignore
                    onChange={(
                      event: React.ChangeEvent<{}>,
                      value: string[] | null
                    ) => {
                      // @ts-ignore
                      setDataFilters({
                        ...dataFilters,
                        IdMotivoDesqualificacaoLead365: value,
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder=""
                        variant="outlined"
                      />
                    )}
                  />
                </>
              }
            />
          </>
        ) : (
          <></>
        )}
        <RenderByCargo
          cargo={codigoCargo2013}
          isSuperintendente={
            <>
              <Styles.CheckboxContainer>
                <CheckBox
                  size="small"
                  style={{
                    color: dataFilters?.LeadsDesqualificados
                      ? color.primary
                      : color.GreyCheck,
                  }}
                  checked={dataFilters?.LeadsDesqualificados}
                  onClick={(e: any) =>
                    setDataFilters({
                      ...dataFilters,
                      LeadsDesqualificados: e?.target?.checked,
                    })
                  }
                />
                <p>Visualizar somente leads do bolsão</p>
              </Styles.CheckboxContainer>
            </>
          }
          isGerenteVendas={
            <>
              <Styles.CheckboxContainer>
                <CheckBox
                  size="small"
                  style={{
                    color: dataFilters?.LeadsDesqualificados
                      ? color.primary
                      : color.GreyCheck,
                  }}
                  checked={dataFilters?.LeadsDesqualificados}
                  onClick={(e: any) =>
                    setDataFilters({
                      ...dataFilters,
                      LeadsDesqualificados: e?.target?.checked,
                    })
                  }
                />
                <p>Visualizar somente leads do bolsão</p>
              </Styles.CheckboxContainer>
            </>
          }
        />
        {showHierarchy && (
          <>
            <DivisorContainer>
              <Styles.LabelModal style={{ margin: "30px 0" }}>
                Responsável
              </Styles.LabelModal>
            </DivisorContainer>
            {showDiretorFilters && (
              <>
                <Styles.LabelText>Superintendente</Styles.LabelText>
                <Styles.Autocomplete
                  fullWidth
                  id="filtro-carteira-superintendente"
                  size="small"
                  options={superintendentesOptions}
                  getOptionLabel={(option: any) => option.label || ""}
                  // @ts-ignore
                  getOptionSelected={(option: any, value: any) =>
                    option.value === value.value
                  }
                  value={dataFilters?.SuperintendenteSelecionado || null}
                  onChange={(_event: any, value: any) =>
                    setDataFilters({
                      ...dataFilters,
                      SuperintendenteSelecionado: value || null,
                      EquipeSelecionada: null,
                      CorretorSelecionado: null,
                    })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Selecionar Superintendente"
                      variant="outlined"
                    />
                  )}
                />
              </>
            )}
            <Styles.LabelText style={{ marginTop: 12 }}>
              Equipe
            </Styles.LabelText>
            <Styles.Autocomplete
              fullWidth
              id="filtro-carteira-equipe"
              size="small"
              options={equipesHierarquiaOptions}
              disabled={showDiretorFilters && !superintendenteSelecionado}
              getOptionLabel={(option: any) => option.label || ""}
              // @ts-ignore
              getOptionSelected={(option: any, value: any) =>
                option.value === value.value
              }
              value={dataFilters?.EquipeSelecionada || null}
              onChange={(_event: any, value: any) =>
                setDataFilters({
                  ...dataFilters,
                  EquipeSelecionada: value || null,
                  CorretorSelecionado: null,
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Selecionar Equipe"
                  variant="outlined"
                />
              )}
            />
            <Styles.LabelText style={{ marginTop: 12 }}>
              Corretor responsável
            </Styles.LabelText>
            <Styles.Autocomplete
              fullWidth
              id="filtro-carteira-corretor"
              size="small"
              options={corretoresHierarquiaOptions}
              disabled={!equipeSelecionada}
              getOptionLabel={(option: any) => option.label || ""}
              // @ts-ignore
              getOptionSelected={(option: any, value: any) =>
                option.value === value.value
              }
              value={dataFilters?.CorretorSelecionado || null}
              onChange={(_event: any, value: any) =>
                setDataFilters({
                  ...dataFilters,
                  CorretorSelecionado: value || null,
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Selecionar Corretor"
                  variant="outlined"
                />
              )}
            />
          </>
        )}
        {!showHierarchy && (
          <>
            <RenderByCargo
              cargo={codigoCargo2013}
              isGerenteVendas={
                <>
                  <DivisorContainer>
                    <Styles.LabelModal style={{ margin: "30px 0" }}>
                      Responsável
                    </Styles.LabelModal>
                  </DivisorContainer>
                  <Styles.LabelText style={{ marginTop: 12 }}>
                    Corretor responsável
                  </Styles.LabelText>
                </>
              }
            />
            <RenderByCargo
              cargo={codigoCargo2013}
              isGerenteVendas={
                isSuccessUsuariosPorEquipeCorretor &&
                transformedListCorretorResponsavel.length > 0 ? (
                  <>
                    <Styles.Autocomplete
                      fullWidth
                      multiple
                      options={transformedListCorretorResponsavel}
                      size="small"
                      disableCloseOnSelect
                      getOptionLabel={(option: any) => option.label || ""}
                      // @ts-ignore
                      getOptionSelected={(option: any, value: any) =>
                        option.label === value.label
                      }
                      value={dataFilters?.IdsCorretores || []}
                      defaultValue={filters?.IdsCorretores || []}
                      // @ts-ignore
                      onChange={(
                        _event: React.ChangeEvent<{}>,
                        value: string[] | null
                      ) => {
                        setDataFilters({
                          ...dataFilters,
                          IdsCorretores: value,
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder=""
                          variant="outlined"
                        />
                      )}
                    />
                  </>
                ) : (
                  <Styles.AutoCompleteDisabled />
                )
              }
            />
          </>
        )}
        <DivisorContainer>
          <Styles.LabelModal style={{ margin: "30px 0" }}>
            Características do lead
          </Styles.LabelModal>
        </DivisorContainer>
        <Styles.LabelModal>Lead é cliente?</Styles.LabelModal>
        <Styles.RadioGroup
          style={{ marginBottom: 12 }}
          aria-labelledby="demo-radio-buttons-group-label"
          // @ts-ignore
          defaultValue={filters?.IdentificaCliente || null}
          name="radio-buttons-group"
          onChange={(e) =>
            setDataFilters({
              ...dataFilters,
              IdentificaCliente: e.target.value,
            })
          }
        >
          <Styles.FormControlLabel
            value="sim"
            control={
              <Styles.Radio
                checked={dataFilters?.IdentificaCliente === "sim"}
                onClick={() =>
                  dataFilters?.IdentificaCliente === "sim" &&
                  setDataFilters({ ...dataFilters, IdentificaCliente: null })
                }
              />
            }
            label="Sim"
          />
          <Styles.FormControlLabel
            value="nao"
            control={
              <Styles.Radio
                checked={dataFilters?.IdentificaCliente === "nao"}
                onClick={() =>
                  dataFilters?.IdentificaCliente === "nao" &&
                  setDataFilters({ ...dataFilters, IdentificaCliente: null })
                }
              />
            }
            label="Não"
          />
        </Styles.RadioGroup>
        <Styles.LabelModal>Visitou o empreendimento?</Styles.LabelModal>
        <Styles.RadioGroup
          style={{ marginBottom: 12 }}
          aria-labelledby="demo-radio-buttons-group-label"
          // @ts-ignore
          defaultValue={filters?.Visitou || null}
          name="radio-buttons-group"
          onChange={(e) =>
            setDataFilters({
              ...dataFilters,
              Visitou: e.target.value,
            })
          }
        >
          <Styles.FormControlLabel
            value="sim"
            control={
              <Styles.Radio
                checked={dataFilters?.Visitou === "sim"}
                onClick={() =>
                  dataFilters?.Visitou === "sim" &&
                  setDataFilters({ ...dataFilters, Visitou: null })
                }
              />
            }
            label="Sim"
          />
          <Styles.FormControlLabel
            value="nao"
            control={
              <Styles.Radio
                checked={dataFilters?.Visitou === "nao"}
                onClick={() =>
                  dataFilters?.Visitou === "nao" &&
                  setDataFilters({ ...dataFilters, Visitou: null })
                }
              />
            }
            label="Não"
          />
        </Styles.RadioGroup>
        <Styles.LabelText style={{ marginBottom: 8 }}>Origem</Styles.LabelText>
        {statusOrigem === "success" ? (
          <>
            <Styles.Autocomplete
              fullWidth
              multiple
              id="checkboxes-tags-demo"
              options={dataOrigem?.data?.map((item: any) => ({
                label: item.nome,
                value: item.id,
              }))}
              size="small"
              disableCloseOnSelect
              getOptionLabel={(option: any) => option.label || ""}
              getOptionSelected={(option, value) =>
                // @ts-ignore
                option.label === value.label
              }
              value={dataFilters?.IdsOrigem || []}
              // @ts-ignore
              defaultValue={filters?.IdsOrigem || []}
              // @ts-ignore
              onChange={(event: any, value: string | null) => {
                // @ts-ignore
                setDataFilters({ ...dataFilters, IdsOrigem: value || [] });
              }}
              renderInput={(params) => (
                <TextField {...params} placeholder="" variant="outlined" />
              )}
            />
          </>
        ) : (
          <>
            <Skeleton variant="rounded" width="100%" height={40} />
          </>
        )}
        <Styles.LabelText style={{ marginTop: 16, marginBottom: 8 }}>
          Canal
        </Styles.LabelText>
        {loadingCanais ? (
          <>
            <Skeleton variant="rounded" width="100%" height={40} />
          </>
        ) : (
          <>
            <Styles.Autocomplete
              fullWidth
              multiple
              disabled={
                !dataFilters?.IdsOrigem || dataFilters?.IdsOrigem.length === 0
              }
              id="checkboxes-tags-demo"
              options={canaisContato}
              size="small"
              disableCloseOnSelect
              getOptionLabel={(option: any) => option.label || ""}
              // @ts-ignore
              getOptionSelected={(option: any, value: any) =>
                option.label === value.label
              }
              value={dataFilters?.IdsCanalContato || []}
              // @ts-ignore
              defaultValue={filters?.IdsCanalContato || []}
              // @ts-ignore
              onChange={(event: any, value: string | null) => {
                // @ts-ignore
                setDataFilters({
                  ...dataFilters,
                  IdsCanalContato: value || [],
                });
              }}
              renderInput={(params) => (
                <TextField {...params} placeholder="" variant="outlined" />
              )}
            />
          </>
        )}
        {filters?.TipoVisualizacao !== 2 && (
          <>
            <Styles.LabelText style={{ marginTop: 16 }}>Etapa</Styles.LabelText>
            <ToggleBtns
              data={etapasData}
              value={dataFilters?.Etapas}
              onChange={(newValues: any) => {
                setDataFilters({
                  ...dataFilters,
                  Etapas: newValues,
                });
              }}
            />
            <Styles.LabelText style={{ marginTop: 16, marginBottom: 8 }}>
              Subetapa
            </Styles.LabelText>{" "}
            <Styles.Autocomplete
              disabled={
                dataFilters?.Etapas?.length <= 0 ||
                dataFilters?.Etapas === undefined
              }
              multiple
              id="checkboxes-tags-demo"
              options={
                dataSubEtapa
                  ? dataSubEtapa?.subEtapas.map((item: any) => ({
                      label: item?.nome,
                      value: item?.id,
                    }))
                  : []
              }
              size="small"
              disableCloseOnSelect
              getOptionLabel={(option: any) => option?.label || ""}
              // @ts-ignore
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              getOptionSelected={(option: any, value: any) =>
                option?.label === value?.label
              }
              value={dataFilters?.IdSubEtapaFunil365 || []}
              // @ts-ignore
              defaultValue={filters?.IdSubEtapaFunil365 || []}
              // @ts-ignore
              onChange={(event: any, value: string | null) => {
                // @ts-ignore
                setDataFilters({
                  ...dataFilters,
                  IdSubEtapaFunil365: value,
                });
              }}
              renderInput={(params) => (
                <TextField {...params} placeholder="" variant="outlined" />
              )}
            />
          </>
        )}
        <Styles.LabelText style={{ marginTop: 16 }}>Etiquetas</Styles.LabelText>
        <ToggleBtnsColors
          data={etiquetasData}
          value={dataFilters?.IdsEtiquetas}
          onChange={(newValues: any) => {
            setDataFilters({
              ...dataFilters,
              IdsEtiquetas: newValues,
            });
          }}
        />
        <Styles.LabelText style={{ marginTop: 16 }}>
          Status do lead
        </Styles.LabelText>
        <ToggleBtnsFarol
          data={statusData}
          value={dataFilters?.Status}
          onChange={(newValues: any) => {
            setDataFilters({
              ...dataFilters,
              Status: newValues,
            });
          }}
        />
        <Styles.LabelText style={{ marginTop: 16 }}>
          Temperatura
        </Styles.LabelText>
        {statusTemperatura === "success" ? (
          <>
            <ToggleBtns
              data={dataTemperatura?.data?.map(
                (item: { nome: string; id: string }) => {
                  return {
                    label: item.nome,
                    value: item.id,
                  };
                }
              )}
              value={dataFilters?.IdsTemperaturasLead}
              onChange={(newValues: any) => {
                setDataFilters({
                  ...dataFilters,
                  IdsTemperaturasLead: newValues,
                });
              }}
            />
          </>
        ) : (
          <>
            <Skeleton variant="rounded" width="100%" height={40} />
          </>
        )}
        <Styles.LabelText style={{ marginTop: 16, marginBottom: 8 }}>
          Renda familiar
        </Styles.LabelText>{" "}
        <Styles.Autocomplete
          fullWidth
          multiple
          id="checkboxes-tags-demo"
          options={rendas.map((item: any) => ({
            label: item.nome,
            value: item.id,
          }))}
          size="small"
          disableCloseOnSelect
          getOptionLabel={(option: any) => option.label || ""}
          // @ts-ignore
          getOptionSelected={(option, value) => option.label === value.label}
          value={dataFilters?.IdsRendaFamiliares || []}
          // @ts-ignore
          defaultValue={filters?.IdsRendaFamiliares || []}
          // @ts-ignore
          onChange={(event: any, value: string | null) => {
            // @ts-ignore
            setDataFilters({ ...dataFilters, IdsRendaFamiliares: value });
          }}
          renderInput={(params) => (
            <TextField {...params} placeholder="" variant="outlined" />
          )}
        />
        <DivisorContainer>
          <Styles.LabelModal style={{ margin: "30px 0" }}>
            Preferências do lead
          </Styles.LabelModal>
        </DivisorContainer>
        {/* <Tooltip
          title={
            <p>
              O filtro de produto de interesse <br /> foi removido
              temporariamente
            </p>
          }
          followCursor
          arrow
          placement="top"
        >
          <div
            style={{
              display: "flex",
              marginTop: 16,
              marginBottom: 8,
            }}
          >
            <Styles.LabelText>Produto de origem</Styles.LabelText>

            <IconsSVG.WarningIcon
              style={{
                marginTop: 2,
                marginLeft: 4,
              }}
            />
          </div>
        </Tooltip> */}
        <Styles.LabelText>Produto de interesse</Styles.LabelText>
        <Styles.Autocomplete
          multiple
          id="checkboxes-tags-demo"
          options={produtos.map((item: any) => ({
            label: item.nome,
            value: item.id,
          }))}
          ref={autocompleteRef}
          size="small"
          disableCloseOnSelect
          disabled={disabledProdutoInteresse}
          // @ts-ignore
          defaultValue={filters?.IdsEmpreendimentos || []}
          getOptionLabel={(option: any) => option.label || ""}
          // @ts-ignore
          getOptionSelected={(option, value) => option.label === value.label}
          value={dataFilters?.IdsEmpreendimentos || []}
          // @ts-ignore
          onChange={(event: any, value: string | null) => {
            // @ts-ignore
            setDataFilters({ ...dataFilters, IdsEmpreendimentos: value });
          }}
          renderInput={(params) => (
            <TextField {...params} placeholder="" variant="outlined" />
          )}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <Styles.LabelText style={{ marginTop: 16, fontSize: 13 }}>
            Visualizar apenas leads sem produto
          </Styles.LabelText>
          <Styles.Switch
            checked={dataFilters?.SemEmpreendimentoInteresse}
            onChange={(e) =>
              setDataFilters({
                ...dataFilters,
                SemEmpreendimentoInteresse: e.target.checked,
              })
            }
          />
        </div>
        <Styles.LabelText style={{ marginTop: 16 }}>
          Tipo de empreendimento
        </Styles.LabelText>
        <ToggleBtns
          data={empreendimentoData}
          value={dataFilters?.IdsTipoEmpreendimentos}
          onChange={(newValues: any) => {
            setDataFilters({
              ...dataFilters,
              IdsTipoEmpreendimentos: newValues,
            });
          }}
        />
        <Styles.LabelText style={{ marginTop: 16 }}>
          Dormitórios (Quartos)
        </Styles.LabelText>
        <ToggleBtns
          data={quartosData}
          value={dataFilters?.QuantidadesDormitorios}
          onChange={(newValues: any) => {
            setDataFilters({
              ...dataFilters,
              QuantidadesDormitorios: newValues,
            });
          }}
        />
        <Styles.LabelText style={{ marginTop: 16 }}>Zona</Styles.LabelText>
        <ToggleBtns
          data={zonasData}
          value={dataFilters?.IdsZonasEmpreendimentos}
          onChange={(newValues: any) => {
            setDataFilters({
              ...dataFilters,
              IdsZonasEmpreendimentos: newValues,
            });
          }}
        />
        <Styles.LabelText style={{ marginTop: 16, marginBottom: 8 }}>
          Bairro
        </Styles.LabelText>
        <Styles.Autocomplete
          disabled={
            dataFilters?.IdsZonasEmpreendimentos?.length <= 0 ||
            dataFilters?.IdsZonasEmpreendimentos === undefined
          }
          multiple
          id="checkboxes-tags-demo"
          options={bairros.map((item: any) => ({
            label: item.label,
            value: item.value,
          }))}
          size="small"
          disableCloseOnSelect
          getOptionLabel={(option: any) => option.label || ""}
          // @ts-ignore
          getOptionSelected={(option, value) => option.label === value.label}
          value={dataFilters?.IdsBairrosEmpreendimentos || []}
          // @ts-ignore
          defaultValue={filters?.IdsBairrosEmpreendimentos || []}
          // @ts-ignore
          onChange={(event: any, value: string | null) => {
            // @ts-ignore
            setDataFilters({
              ...dataFilters,
              IdsBairrosEmpreendimentos: value,
            });
          }}
          renderInput={(params) => (
            <TextField {...params} placeholder="" variant="outlined" />
          )}
        />
        <Styles.LabelModal style={{ marginTop: 16, marginBottom: 16 }}>
          Valor do imóvel
        </Styles.LabelModal>
        <Styles.Row style={{ alignItems: "center" }}>
          <CurrencyFormat
            customInput={Styles.TextField}
            value={dataFilters?.InicioIntervaloValorImovel}
            onValueChange={(values) =>
              setDataFilters({
                ...dataFilters,
                InicioIntervaloValorImovel: values.value,
              })
            }
            variant="outlined"
            thousandSeparator="."
            decimalSeparator=","
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">R$</InputAdornment>
              ),
            }}
          />
          <Styles.TextCenter>até</Styles.TextCenter>
          <CurrencyFormat
            customInput={Styles.TextField}
            value={dataFilters?.FimIntervaloValorImovel}
            onValueChange={(values) =>
              setDataFilters({
                ...dataFilters,
                FimIntervaloValorImovel: values.value,
              })
            }
            variant="outlined"
            thousandSeparator="."
            decimalSeparator=","
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">R$</InputAdornment>
              ),
            }}
          />
        </Styles.Row>
        <Styles.LabelText style={{ marginTop: 16 }}>
          Objetivos da compra
        </Styles.LabelText>
        <ToggleBtns
          data={objetivosData}
          value={dataFilters?.IdsObjetivosCompra}
          onChange={(newValues: any) => {
            setDataFilters({
              ...dataFilters,
              IdsObjetivosCompra: newValues,
            });
          }}
        />
        <Styles.LabelText style={{ marginTop: 16 }}>
          Prazo de entrega
        </Styles.LabelText>
        <ToggleBtns
          data={prazosData}
          value={dataFilters?.IdsPrazosEntrega}
          onChange={(newValues: any) => {
            setDataFilters({
              ...dataFilters,
              IdsPrazosEntrega: newValues,
            });
          }}
        />
      </Styles.ContentModal>
      <Styles.FooterModal>
        <ThemeProvider theme={theme}>
          <Styles.Button
            disabled={filterButtonDisabled}
            onClick={handleFilters}
          >
            Aplicar filtro
          </Styles.Button>
        </ThemeProvider>
      </Styles.FooterModal>

      {/* Modal de confirmação de exclusão */}
      {confirmDeleteId && (
        <Styles.ConfirmDeleteOverlay>
          <Styles.ConfirmDeleteModal>
            <Styles.ConfirmDeleteIcon>
              <FiTrash2 size={20} color="#e53935" />
            </Styles.ConfirmDeleteIcon>
            <Styles.ConfirmDeleteTitle>
              Excluir filtro salvo?
            </Styles.ConfirmDeleteTitle>
            <Styles.ConfirmDeleteText>
              {`Você está prestes a excluir o filtro "${confirmDeleteNome}". Esta ação não poderá ser desfeita.`}
            </Styles.ConfirmDeleteText>
            <Styles.ConfirmDeleteActions>
              <Styles.ConfirmDeleteCancelBtn
                type="button"
                onClick={() => {
                  setConfirmDeleteId(null);
                  setConfirmDeleteNome("");
                }}
              >
                Cancelar
              </Styles.ConfirmDeleteCancelBtn>
              <Styles.ConfirmDeleteConfirmBtn
                type="button"
                disabled={excluirFiltro.isLoading}
                onClick={handleDeleteFilter}
              >
                Sim, excluir
              </Styles.ConfirmDeleteConfirmBtn>
            </Styles.ConfirmDeleteActions>
          </Styles.ConfirmDeleteModal>
        </Styles.ConfirmDeleteOverlay>
      )}
    </>
  );
};

export default FiltersContent;
